import axios from "axios";

export const getFisher = async (userID: any) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/User/get-fisher?UserID=${userID}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
